import { connect } from 'react-redux'
import { Dispatch } from 'redux'
import { languageChanged } from '../../actions/userAccount/user/switchLanguage'
import { ILanguageSwitcherDispatch } from '../../containers/Template/Header/Menu/LanguageSwitcher/LanguageSwitcher'
import { CountryCode } from '../../i18n/countryCodes'
import { IStore } from '../../reducers'
import { isUserAuthorized } from '../../reducers/userAccount/selectors/credentials'
import { IIsAuthorized } from '../../routes/withProtected/Protected'

const mapStateToProps = () => {
  const isAuth = isUserAuthorized

  return (state: IStore): IIsAuthorized => ({
    isAuthorized: isAuth(state),
  })
}

function bindDispatchToProps(dispatch: Dispatch): ILanguageSwitcherDispatch {
  return {
    switchLanguage(countryCode: CountryCode) {
      return function() {
        dispatch(languageChanged(countryCode))
      }
    },
  }
}

export default connect(
  mapStateToProps(),
  bindDispatchToProps,
)
